const menu = document.getElementById('menu');
const secciones = document.querySelectorAll('.seccion');
let refs  = document.querySelectorAll('.menues');

var refes=refs.target;

//console.log(refes);
var texto = refs[0].innerText;

//let indexSeccionActiva;

// Observer
const observer = new IntersectionObserver((entradas, observer) => {

	entradas.forEach(entrada => {
		if(entrada.isIntersecting){
            //entrada.target.classList.add('visible');
			////console.log(entrada.isIntersecting);
            //const entry = entrada.target.id;


			// console.log(entry);
            //if (entry==="novedades"){
            //    //console.log("se hizo");
            //    //refs[2].classList.add('active');
            //}else {
            //    //console.log("no se hizo");
            //    //refs[2].classList.remove('active');
            //}
    
      
			let indexSeccionActiva = [...secciones].indexOf(entrada.target);
            //console.log(indexSeccionActiva+1);

            let indexSeccionActiva1 = indexSeccionActiva+1
            //console.log(refs.indexOf(''));
            //refs[indexSeccionActiva].classList.add('active');

            refs.forEach((tab, index)=> {
                if (index===indexSeccionActiva1) {
                    //console.log("Se activa");
                    refs[index].classList.add('active')
                }else {
                    //console.log("Se desactiva");
                    refs[index].classList.remove('active')
                }
                
                //console.log(tab);
                //console.log(index);

                //indexSeccionActiva.forEach(tab=>{refs.classList.remove('active')})
                //    refs.classList.add('active');
            
                    //var line=document.querySelector('.line');
                    //line.style.width= e.target.offsetWidth + "px";
                    //line.style.left= e.target.offsetLeft+ "px";
            
                    //all_content.forEach(content=>{content.classList.remove('active')})
                    //all_content[index].classList.add('active');
                });
            
             
            };


            //refs.forEach(ref => {
            //   if(indexSeccionActiva===refs.[indexSeccionActiva]){} 
            //})
            
		
});
}, {
	rootMargin: '-15% 0px -70% 0px',
	threshold: 0.2
    
});

// Agregamos un observador para el hero.
observer.observe(document.getElementById('pagina'));

// Asignamos un observador a cada una de las secciones
secciones.forEach(seccion => observer.observe(seccion));

// Evento para cuando la pantalla cambie de tamaño.
